import styled from "styled-components";

export const MessagesWrapper = styled.div`
  display: flex;

  .ahp-header {
    background-color: #1d1d1d;
  }
  .ahp-header img {
    width: 180px;
    padding: 20px;
  }

  .ahp-img-background {
    height: 160px;
    background-size: cover;
    background-position: center;
  }

  .message-context {
    display: inline-block;
    background-color: rgb(184, 199, 85);
    text-transform: uppercase;
    margin-left: 20px;
    margin-top: 30px;
    color: white;
  }

  .ahp-name-product {
    padding: 5px 10px;
    display: inline-block;
    background-color: rgb(76, 76, 76);
    font-weight: 900;
    color: white;
    font-size: 1.2rem;
  }

  .ahp-name-store,
  .ahp-name-agent {
    font-weight: 600;
    padding: 2px 10px;
    font-size: 1rem;
  }

  .message-board {
    position: relative;
    overflow: auto;
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    height: 300px;
    margin: 0 auto;
    border-bottom: 1px solid grey;
  }

  .ahp-message-pane {
    width: 60%;
  }

  .ahp-message {
    position: relative;
    // width: 60%;
    border-style: solid;
    border-width: thin;
    border-color: lightgrey;
    padding: 5px 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    font-size: 1rem;
  }

  .ahp-message:focus {
    border: 1px solid red; !important
  }

  .ahp-message.sent {
    position: relative;
    margin-left: auto;
    background-color: ivory;
    margin-right: 10px;
  }

  .ahp-message.received {
    position: relative;
    margin-right: auto;
    background-color: lightblue;
    margin-left: 10px;
  }

  .ahp-time {
    text-align: right;
    color: grey;
    font-size: 0.8rem;
  }

  .action-footer {
    display: flex;
    margin-top: 20px;
  }

  .message-textarea {
    width: 100%;
    margin: 0px 10px 0px 10px;
    font-size: 1rem;
  }

  .ahp-btn-send {
    background-color: #bbb2c4;
    color: white;
    text-transform: uppercase;
    border-style: none;
    margin-right: 10px;
    cursor: pointer;
  }

`;
